export function formatSar(n: number | null | undefined, lang: 'ar' | 'en' = 'ar'): string {
  if (n == null) return lang === 'ar' ? 'غير متوفر' : 'n/a';
  const abs = Math.abs(n);
  const rounded = abs >= 1e9
    ? (n / 1e9).toFixed(2) + (lang === 'ar' ? ' مليار ريال' : 'B SAR')
    : abs >= 1e6
    ? (n / 1e6).toFixed(1) + (lang === 'ar' ? ' مليون ريال' : 'M SAR')
    : Math.round(n).toLocaleString('en-US') + (lang === 'ar' ? ' ريال' : ' SAR');
  return rounded;
}

export function formatUsd(n: number): string {
  if (n < 0.01) return '$' + n.toFixed(4);
  if (n < 1) return '$' + n.toFixed(3);
  return '$' + n.toFixed(2);
}

export function relativeTime(ts: number, lang: 'ar' | 'en' = 'ar'): string {
  const secs = Math.floor((Date.now() - ts) / 1000);
  if (secs < 60) return lang === 'ar' ? `قبل ${secs} ث` : `${secs}s ago`;
  const mins = Math.floor(secs / 60);
  if (mins < 60) return lang === 'ar' ? `قبل ${mins} د` : `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  return lang === 'ar' ? `قبل ${hours} س` : `${hours}h ago`;
}

export function detectLang(text: string): 'ar' | 'en' {
  return /[\u0600-\u06FF]/.test(text) ? 'ar' : 'en';
}
